// extracted by mini-css-extract-plugin
module.exports =  {"Loading":"Tbt6W1wZQGr5KrejVWtU","Loading__Icon":"hhYw3wBQfwDXsZ1k2J9A","load":"xfjmmDteTU1CIO2XNcqQ","Loading--small":"kbyBAWOh2nA6PREeJvTn","LoadingSmall":"kbyBAWOh2nA6PREeJvTn"};